import { render } from "./SideMenu.html?vue&type=template&id=7fd86864&scoped=true&ts=true&external"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.scss?vue&type=style&index=0&id=7fd86864&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd86864"]])

export default __exports__